import React from "react";
import { SWRConfig } from "swr";
import { SideNavigation } from "components/common/navigation";
import AxiosManager from "service/api/_axiosManager";
import { Router } from "./Router";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  const swrConfig = {
    fetcher(url: string, params: any) {
      return AxiosManager.getInstance()
        .get(url, params)
        .then((res) => res.data);
    },
  };

  return (
    <SWRConfig value={swrConfig}>
      {location.pathname.includes("/login") ? (
        <Router />
      ) : (
        <SideNavigation>
          <Router />
        </SideNavigation>
      )}
    </SWRConfig>
  );
}

export default App;
